module.exports = __webpack_public_path__ + "img/hong_kong_society_for_quality.b479274d.png";